module.exports = __webpack_public_path__ + "img/bus-grey.26b2311a.svg";